import React from 'react';
import MvCheckBox from 'Generic/MvCheckBox';
import './styles.sass'
import { Term } from 'Interfaces/BookResort';
import ReactHtmlParser, { Transform } from 'react-html-parser';
import ToolTip from "Generic/ToolTip";
import { Tip } from "Interfaces/TipInterface";
import MvLink from 'Generic/MvLink';

export interface Props {
    onChange: (type: string) => void;
    heading: string;
    subHeading: string;
    instructions: Term[];
    submissionFailed?: boolean;
    readOnly?: boolean;
};

const MvTermsConditions = ({
    onChange,
    heading,
    subHeading,
    instructions,
    submissionFailed,
    readOnly
}: Props) => {
    
    /**
     * find and replace all tooltips
     * 
     * tooltips will have the following format:
     *      {​​<T}​​ Premium Points|sr-premium-points{​​T>}
     *      The left side of pipe is the text to render
     *      The right side of pipe is the tooltip text
     */
    const fNRTooltips = (text: string): JSX.Element[] => {
        const openTag = '{​​<T}';
        const closeTag = '{​​T>}';
        const regex = /({​​<T}.*?{​​T>})/;

        const returnJsx: JSX.Element[] = [];

        if (text.indexOf(openTag) === -1) {
            return [<>{text}</>];
        };

        // use regex to split text into text and tooltip segments
        const parts = text.split(regex);

        for (let part of parts) {
            // isn't a tooltip segment
            if (part.indexOf(openTag) === -1) {
                returnJsx.push(<>{part}</>);
            } else {
                // remove outer delimiting tags
                part = part.replace(openTag, '');
                part = part.replace(closeTag, '');

                // split into text and tooltip text
                const [text, tooltipText] = part.split('|');

                // const tooltip
                const tooltip: Tip[] = [
                    {
                      label: "",
                      desc: `static.content.${tooltipText}`,
                    },
                ];

                // push Tooltip component to return Jsx
                returnJsx.push(
                    <span className='tooltip-text'>
                        <ToolTip useRefToPosition={false} tabIndex={0} tip={tooltip} id={`mv-terms-${text}`}>
                            <MvLink label={text} onClick={() => {}} />      
                        </ToolTip>
                    </span>
                );
            }
        }

        return returnJsx;
    };

    const transformTermNodes = (node: any, index: number) => {
        if (node.type === 'text') {
            return fNRTooltips(node.data as string);
        }
    };

    const areAllTnCAccepted = () => {
        const acceptedTnC = instructions.filter(item => item.checked);        
        return acceptedTnC.length === instructions.length
    }

    return (
        <div className='mv-tnc'>
            <h3>{heading}</h3>
            {!readOnly && <p className={`subHeader ${(submissionFailed && !areAllTnCAccepted()) ? 'required' : ''}`}>{subHeading}</p>}
            {instructions.map((item) => (
                    <div className={`instruction_item ${(submissionFailed && !item.checked && item.acknowledgementNeeded === 'true') ? 'required' : ''}`}>
                    {!readOnly && <MvCheckBox
                        label=""
                        id={item.type}
                        checked={item.checked}
                        onChange={(e) => onChange(item.type)} />}
                    <div className={`instruction_item_content ${readOnly ? 'read-only' : ''}`}>
                        {ReactHtmlParser(item.description, { transform: (transformTermNodes as Transform) })}
                    </div>
                </div>
            ))}
        </div>
    );
};

export {
    MvTermsConditions,
};
